import { Box } from "@material-ui/core";
import styled from "styled-components";

export default styled(Box)`
  && {
    z-index: 2;
    display: flex;
    margin: 20px auto;
    background-color: white;
    padding: ${props => props.padding || "20px"};
    border-radius: ${props => props.borderRadius || "8px"};
    flex-direction: ${props => (props.row ? "row" : "column")};
    max-width: ${props => (props.maxwidth ? props.maxwidth + "%" : "100%")};
    cursor: ${props =>
      props.onClick ? "pointer" : props.pointer ? "pointer" : "default"};
  }
`;
